import { render, staticRenderFns } from "./CustomerInvoiceSplit.vue?vue&type=template&id=47fc9694&scoped=true"
import script from "./CustomerInvoiceSplit.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceSplit.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoiceSplit.vue?vue&type=style&index=0&id=47fc9694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc9694",
  null
  
)

export default component.exports